import get from 'lodash/get';
import store from '~/store';

export const getCode = (res) => {
  const code = get(res, 'data.extInfo.processVarMap.nodeCode');
  if(!code) throw new Error();
  const btn = get(res, 'data.info.btnList');
  let nextNode = get(res, 'data.extInfo.nextNode');
  let verifyUrl = get(res, 'data.info.url');
  let id = get(res, "data.extInfo.processVarMap.bookItem.id") || get(res, "data.extInfo.processVarMap.bidItem.id") 
  if(btn) {
    const targetBtn = btn.find(e=>(e.action.startsWith('bid') || e.action.startsWith('book')));
    if(targetBtn) {
      nextNode = targetBtn.action.replace(/^.*:\/\//, '');
    }
  }
  return {code, nextNode, verifyUrl, id};
}

export const status = { 
  BOOK_SUCCESS: "c_book_success",
  NOT_IN_NETWORK: "c_not_in_network",
  NOT_IN_NETWORK_BID: "c_not_in_network_bid",
  L2_PENDING: "c_l2_pending_tip",
  BOOK_CONFIRM: "c_make_sure_book_now",
  BOOK_ALREADY: "c_not_rebook_tip",
  BOOK_UNAVALIABLE: "c_load_not_available_book",
  LOADSMART_PENDING: "c_load_smart_pending_tip",
  LOADSMART_REJECT: "c_ls_manual_re_upload_tip",
  LOADSMART_AUTO_UPLOAD: "c_ls_auto_upload_verify",
  LOADSMART_MANUAL_UPLOAD: "c_ls_manual_upload_verify",
  BID_PRICE: "c_fill_bid_price",
  BID_SUCCESS: "c_bid_success",
  BID_UNAVALIABLE: "c_load_not_available_bid",
  BID_WAITING: "c_bid_waiting_accept",
  BID_PROFILE_VAILD: "c_bid_parade_user_info_fill"
}

export const bidStatus = {
  BID_LOAD_DROP:  "load_dropped",
  BID_LOAD_DELETED:  "load_deleted",
  BID_LOAD_REJECT:  "pending_reject",
  BID_AWARD_TIMEOUT:  "award_timeout",
  BID_SENT:  "bid_sent",
  BID_ACCEPTED:  "accepted",
  BID_REJECT:  "rejected",
  BID_UNAVALIABLE:  "ext_expired",
  BID_EXPIRED:  "expired",
  BID_AWARDING:  "awarding",
  BID_LOST: "lost",
  BID_WAITING:  "waiting_for_confirm",
}

export const bookStatus = { 
  BOOK_LOAD_DROP: "load_dropped",
  BOOK_SUCCESS_DEF: "def_book_success",
  BOOK_LOAD_DROP_DEF: "def_load_dropped",
  BOOK_CONFIRM: "def_status",
  BOOK_CONFIRM_WAITING: "waiting_response",
  BOOK_LOAD_DROP_REJ: "rej_load_dropped",
  BOOK_REJECT: "rej_broker_reject",
  BOOK_EXPIRED: "rej_load_expired",
  BOOK_SHIPPER_CANCEL: "rej_shipper_cancel",
  BOOK_CANCEL: "rej_cancel",
  BOOK_SUCCESS: "book_success",
  BOOK_DELIVERED: "delivered",
}


export const getLoadStatus = (id) => {
  const { bids, bookings } = store.getState();
  const bidMap = bids.map;
  const bookMap = bookings.bookingMap;
  const loadStatus = {
    bidId: '',
    bidPrice: '',
    bidStatus: '',
    bookId: '',
    bookStatus: '',
    bidType: '',
    bidMsg: '',
  };
  if(bidMap&&bidMap.has(id)) {
    const {id: bidId, price, status, bidType, nextNode, awardMsg} = bidMap.get(id);
    loadStatus.bidId = bidId;
    loadStatus.bidPrice = price;
    loadStatus.bidStatus = status;
    loadStatus.bidType = bidType;
    loadStatus.bidNextNode = nextNode;
    loadStatus.bidMsg = awardMsg;
  }
  if(bookMap&&bookMap.has(id)) {
    const {bookingId, status, bookType, rcFiles} = bookMap.get(id);
    loadStatus.bookId = bookingId;
    loadStatus.bookStatus = status;
    loadStatus.bookType = bookType;
    loadStatus.rcFiles = rcFiles;
  }
  return loadStatus
  
}




// WEBPACK FOOTER //
// ./src/misc/loadStatus.js